import { useEffect, useState } from "react";
import { useDataProvider } from "react-admin";
import { useWatch } from "react-hook-form";

const isKeramikCategory = (category) =>
  typeof category?.name === "string" &&
  category.name.toUpperCase().includes("KERAMIK");

export default function useSaleOrderIsKeramik() {
  const saleOrderId = useWatch({ name: "sale_order_id" });
  const dataProvider = useDataProvider();
  const [isKeramik, setIsKeramik] = useState(false);

  useEffect(() => {
    let active = true;

    if (!saleOrderId) {
      setIsKeramik(false);
      return () => {
        active = false;
      };
    }

    dataProvider
      .getListNoParams("sale-orders/" + encodeURIComponent(saleOrderId))
      .then((saleOrder) => {
        if (active) setIsKeramik(isKeramikCategory(saleOrder?.category));
      })
      .catch(() => {
        if (active) setIsKeramik(false);
      });

    return () => {
      active = false;
    };
  }, [dataProvider, saleOrderId]);

  return isKeramik;
}
